import * as React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import Link from "./link";
import FormModal from "./form-modal";

const renderOptions = {
  renderNode: {
    [BLOCKS.HEADING_2]: (_node, children) => (
      <h2 className="heading">{children}</h2>
    ),

    [INLINES.HYPERLINK]: (node, children) => (
      <Link href={node.data.uri}>{children}</Link>
    ),
  },
};

const ImageWithText = ({
  image,
  mobileImage,
  imageAlt,
  text,
  link,
  className,
  modal,
}) => {
  const ref = React.useRef(null);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState(false);
  const toggleModal = () => setIsModalOpen(!isModalOpen);
  const Component = modal ? "button" : Link;
  const hasLink = link || modal;

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (image) {
    const imageToDisplay = isMobile && mobileImage ? mobileImage : image;

    return (
      <figure className={`image-with-text ${className || ""}`}>
        <GatsbyImage
          image={imageToDisplay.gatsbyImageData}
          alt={imageAlt ?? image.title}
        />
        {text && (
          <figcaption>
            <div className="container">
              <div>{renderRichText(text, renderOptions)}</div>
            </div>
          </figcaption>
        )}
        {hasLink && (
          <Component
            className={"image-with-text-link"}
            href={modal ? undefined : link}
            type={modal ? "button" : undefined}
            target={modal && undefined}
            onClick={modal ? toggleModal : undefined}
            ref={ref}
          />
        )}
        {modal && (
          <FormModal
            modal={modal}
            isOpen={isModalOpen}
            onClose={toggleModal}
            triggerRef={ref}
          />
        )}
      </figure>
    );
  }

  return null;
};

export default ImageWithText;
